"use client";
import { Phone } from "lucide-react";
import { FaCheck } from "react-icons/fa6";
import { InfoCard, InfoCardHeader } from "@/components/ui/InfoCard";
import { StaffCardCaptureContainer } from "@/features/card-capture/staff";
import { usePatientDetailsContext } from "../../context/PatientDetailsContext";
import { formatPhone } from "@/lib/string";
import { CardChip } from "@/features/payment/components/CardChip";
import RequestCardViaSMSBlock from "../request-card-via-sms-block/RequestCardViaSMSBlock";

interface CardCollectSectionProps {
  linkSent: boolean;
}

export function CardCollectSection({ linkSent }: CardCollectSectionProps) {
  const { patient } = usePatientDetailsContext();

  if (!patient) {
    return null;
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto">
      {/* Patient Details Card */}
      <InfoCard>
        <div className="flex items-center px-5 py-3.5">
          <div className="mr-3 flex shrink-0">
            <Phone
              className="text-action-disabled-content size-3.5"
              strokeWidth={1.8}
            />
          </div>
          <span className="text-content-muted w-[84px] shrink-0 text-[13px] font-medium">
            Phone
          </span>
          <span className="flex-1 text-[13px] font-semibold">
            {patient.phone ? formatPhone(patient.phone) : "—"}
          </span>
          {!patient.cardOnFile &&
            (linkSent ? (
              <span className="rounded-input border-action bg-action inline-flex shrink-0 items-center gap-2 border px-4 py-2 text-[13px] font-semibold whitespace-nowrap text-white">
                <span className="flex size-3.5 shrink-0">
                  <FaCheck className="size-3.5 text-white" />
                </span>
                SMS Sent
              </span>
            ) : (
              <RequestCardViaSMSBlock
                patient={patient}
                surface="SideModal"
                className="py-2"
              />
            ))}
        </div>
      </InfoCard>

      {/* Credit Card on File Card */}
      <InfoCard>
        <InfoCardHeader
          title="Credit Card on File"
          right={
            <CardChip type="status" hasCard={!!patient?.cardOnFile?.last4} />
          }
        />

        <StaffCardCaptureContainer />
      </InfoCard>
    </div>
  );
}
